import { computed } from "vue";
import { storeToRefs } from "pinia";

import { usePricerProjectsStore } from "@stores/pricer/pricerProjects";
import { useUsersStore } from "@stores/users";
import { createFilters } from "@/utils/composables/filters/createFilters";

export const usePricerProjectsFilters = () => {
  const pricerProjectsStore = usePricerProjectsStore();
  const usersStore = useUsersStore();

  const { ownerFilter, customerFilter, endClientFilter, clients, endClients } = storeToRefs(pricerProjectsStore);
  const { adminSalesUsers } = storeToRefs(usersStore);
  const { clearFilters, search } = pricerProjectsStore;

  const ownerOptions = computed(
    () => adminSalesUsers.value?.map(({ full_name, id }) => ({ label: full_name, value: id })) || [],
  );
  const customerOptions = computed(() => clients.value?.map((client) => ({ label: client, value: client })) || []);
  const endClientOptions = computed(() => endClients.value?.map((client) => ({ label: client, value: client })) || []);

  return createFilters({
    filters: [
      {
        id: "owner",
        label: "Owner",
        hasSearch: true,
        options: ownerOptions,
        model: ownerFilter,
      },
      {
        id: "client",
        label: "Client",
        hasSearch: true,
        options: customerOptions,
        model: customerFilter,
      },
      {
        id: "endClient",
        label: "End Client",
        hasSearch: true,
        options: endClientOptions,
        model: endClientFilter,
      },
    ],
    search,
    clear: clearFilters,
  });
};
